import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute } from '@angular/router';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {

  private route = inject(ActivatedRoute);
 
  // ID
  private readonly measurementId: string = environment.gaMeasurementId;
  private readonly team: string | null   =  location.pathname.split('/')[1];

  // Flags
  private hasLoaded:         boolean = false;
  public  hideCookiesBanner: boolean = false;

  init(): void {

    const consent: string | null = localStorage.getItem(`cookiesAccepted_${this.team}`);
    
    if (this.hasLoaded || !this.measurementId || consent !== 'true') return;

    window.dataLayer = window.dataLayer || [];
      window.gtag = function (...args: unknown[]) {
        window.dataLayer.push(...args);
      };

    const script: HTMLScriptElement = document.createElement('script');

    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    script.async = true;

    script.onload = () => {
      setTimeout(() => {
        window.gtag('js', new Date());
        window.gtag('config', this.measurementId, { anonymize_ip: true });
        this.hasLoaded = true;
      });
    };

    script.onerror = () => {
      console.error('Failed to load GA script');
    };

    document.head.appendChild(script);
  }

}
